import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

import '../../index.css';
import Title from '../../components/Title';
import {
  addPayment,
  addWizmonPayment,
  addInicisPayment,
  getUserDetail,
  getInicisPayment,
  getInicisPaymentList,
} from '../../modules/NetworkFunction';
import AuthContext from '../../contexts/AuthContext';
import PaymentTable from '../../components/PaymentTable';
import PaymentAgreementModal from './PaymentAgreementModal';
import { ReactComponent as NextIcon } from '../../icons/ic-next.svg';
import usePaymentStatus from '../../hooks/usePaymentStatus';
import AppStatusTable from '../../components/AppStatusTable';
import ShopModeContext from '../../contexts/ShopModeContext';

function MyPagePayment() {
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);
  const [userInfo, setUserInfo] = useState(null); // user 정보 데이터
  const [isLoaded, setIsLoaded] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const [paymentURL, setPaymentURL] = useState();
  const mallId = window.localStorage.getItem('mallId');
  const [modalOpen, setModalOpen] = useState(false);
  const { paymentData, isPaid } = usePaymentStatus(token);
  const [paymentInicisData, setPaymentInicisData] = useState();
  const accessToken = sessionStorage.getItem('accessToken');
  const [isPromotion, setIsPromotion] = useState(false);
  const [didAgreement, setDidAgreement] = useState(false);
  const [paymentMakeShopData, setPaymentMakeShopData] = useState();
  const [INIAPIKey, setINIAPIKey] = useState('t9SRNHxMH4nzQGXN');
  // const [INIAPIKey, setINIAPIKey] = useState(process.env.REACT_APP_INICIS_INIAPIKEY);
  const [isInicisPaid, setIsInicisPaid] = useState(false);
  console.log('isInicisPaid: ', isInicisPaid);

  const openModal = () => {
    setDidAgreement(false);
    setIsPromotion(false);
    setModalOpen(true);
  };
  const closeModal = () => {
    setDidAgreement(false);
    setIsPromotion(false);
    setModalOpen(false);
  };

  const handleCompletePayment = useCallback(
    (event) => {
      // origin 수정 필요 -> https://shop.wizmon.co.kr
      if (
        event.origin !== 'http://localhost:3000' &&
        event.data.status !== 'success'
      )
        return;
      if (shopMode === 'cafe24') {
        const { pay_token, amount, hmac, trade_id } = event.data.paymentData;
        addPayment(
          {
            paymentDate: new Date(),
            orderId: trade_id,
            price: amount,
            payToken: pay_token,
            hmac,
          },
          () => {},
          (error) => {
            console.error(error);
          },
          token
        );
      } else {
        // 이니시스 결제 이후 로직 처리
        console.log('comeback to payment page');
      }
      history.push('/mypage/payment-success');
    },
    [history, token]
  );

  useEffect(() => {
    if (!isLoaded) {
      getUserDetail(
        null,
        (v) => {
          setUserInfo(v.user);
        },
        setIsLoaded,
        (e) => {
          console.log('getuserdetail', e);
        },
        token
      );
    }
  }, [userInfo, isLoaded]);

  useEffect(() => {
    console.log('shopmode: ', shopMode);
    console.log('history: ', history);
    console.log(shopMode == 'makeshop' && history.location.search != '');
    if (shopMode == 'makeshop' && history.location.search != '') {
      const searchParams = new URLSearchParams(history.location.search);
      const resultParam = searchParams.get('result');
      console.log(resultParam);
      if (resultParam) {
        try {
          const resultJson = JSON.parse(resultParam);
          console.log(resultJson);
          const price = parseInt(resultJson.TotPrice);
          addInicisPayment(
            {
              paymentDate: new Date(),
              userNo: userInfo?.userNo,
              planNo: 2,
              tid: resultJson.tid,
              mid: resultJson.mid,
              price,
              INIAPIKey: INIAPIKey,
            },
            () => {},
            (error) => {
              console.error(error);
            },
            token
          );
          setIsInicisPaid(true);
        } catch (error) {
          console.error('Error parsing result JSON:', error);
        }
      }
      searchParams.delete('result');
      const newSearch = searchParams.toString();
      const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
      history.replace(newUrl);
    }
  }, [history]);

  useEffect(() => {
    getInicisPayment(
      {
        userNo: userInfo?.userNo,
      },
      (v) => {
        console.log(v);
        if (v.payment.length > 0) {
          setIsInicisPaid(true);
        } else {
          setIsInicisPaid(false);
        }
        setPaymentInicisData(v.payment);
      },
      () => {},
      (error) => {
        console.error(error);
      },
      token
    );
  }, [userInfo, history, isInicisPaid, token, shopMode]);

  useEffect(() => {
    window.addEventListener('message', handleCompletePayment);

    return () => {
      window.removeEventListener('message', handleCompletePayment);
    };
  }, [handleCompletePayment]);

  useEffect(() => {
    if (!mallId || !accessToken) return;

    addWizmonPayment(
      {
        mallId: mallId,
        token: accessToken,
        redirectURI: window.location.origin + '/mypage/payment-success',
      },
      (data) => {
        setPaymentURL(data.confirmation_url);
      },
      (e) => {
        console.log('addWizmonPayment', e);
      },
      token
    );
  }, [accessToken, mallId, token]);

  return (
    <div>
      <PaymentAgreementModal
        open={modalOpen}
        close={closeModal}
        paymentURL={paymentURL}
        isPromotion={isPromotion}
        setIsPromotion={setIsPromotion}
        didAgreement={didAgreement}
        setDidAgreement={setDidAgreement}
      />
      <Title title="결제 관리" />
      <div className="inner-box" style={{ marginTop: 32 }}>
        <div
          style={{ flex: 1, alignItems: 'center' }}
          className="checkbox-list"
        >
          <img
            src={'/icons/ic-check.png'}
            alt="check"
            style={{ width: 20, height: 12 }}
          />
          <label>
            <span
              style={{
                marginLeft: 15,
                fontSize: 18,
              }}
            >
              서비스 연장 결제 시, 서비스 사용 기간이 연장됩니다.
            </span>
          </label>
        </div>
        <div
          style={{ flex: 1, alignItems: 'center' }}
          className="checkbox-list"
        >
          <img
            src={'/icons/ic-check.png'}
            alt="check"
            style={{ width: 20, height: 12 }}
          />
          <label>
            <span
              style={{
                marginLeft: 15,
                fontSize: 18,
              }}
            >
              서비스 사용 기간이 만료되면 ‘무료버전’으로 변경되며, 일부 컨텐츠는
              ‘접근제한’으로 전환됩니다.
            </span>
          </label>
        </div>
      </div>
      <AppStatusTable token={token} />
      <div className="inner-box">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: 750,
            marginBottom: 15,
          }}
        >
          <p className="subtitle" style={{ marginBottom: 0 }}>
            결제 내역
          </p>
          <Link
            to={{
              pathname: '/mypage/payment-list',
              state: { userNo: userInfo?.userNo },
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              color: '#B5B5B5',
              fontSize: 14,
              wordWrap: 'break-word',
            }}
          >
            더보기
            <NextIcon
              stroke="#B5B5B5"
              strokeWidth="1.5"
              style={{ marginLeft: 5 }}
            />
          </Link>
        </div>

        <div
          style={{
            overflow: 'hidden',
            border: '1px solid #CCC',
            borderRadius: 5,
            width: 750,
            marginBottom: 10,
          }}
        >
          <PaymentTable
            payments={shopMode === 'cafe24' ? paymentData : paymentInicisData}
            rowCount={2}
            setIsInicisPaid={setIsInicisPaid}
          />
        </div>
        <p
          style={{
            fontSize: 12,
            color: '#848484',
            fontWeight: 500,
            fontFamily: 'Noto Sans',
          }}
        >
          * 환불은{' '}
          <a
            href="https://www.notion.so/be5bba159837406b8c6ffef69daffc87"
            target="_blank"
            rel="noreferrer"
            style={{
              color: '#FF7A00',
              textDecoration: 'underline',
              textUnderlineOffset: '1px',
            }}
          >
            환불규정 안내
          </a>{' '}
          참고 부탁드립니다.
        </p>
      </div>

      <div //결제하기 버튼 container
        style={{
          position: 'absolute',
          bottom: 36,
          right: 107,
          display: 'flex',
          flexDirection: 'row',
          gap: 18,
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {shopMode === 'cafe24' && !isPaid && (
          <>
            <span
              style={{
                fontSize: 16,
                color: '#B5B5B5',
                fontWeight: '300',
              }}
            >
              아직 결제 내역이 없습니다.
            </span>
            <button
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '40px',
                fontWeight: '700',
                padding: '10px 30px',
                borderRadius: '20px',
                color: '#ffffff',
                backgroundColor: '#FFB600',
                fontSize: '20px',
                cursor: 'pointer',
                borderWidth: 0,
              }}
              onClick={openModal}
            >
              결제하러 가기
            </button>
          </>
        )}
        {shopMode === 'makeshop' && !isInicisPaid && (
          <>
            <span
              style={{
                fontSize: 16,
                color: '#B5B5B5',
                fontWeight: '300',
              }}
            >
              아직 결제 내역이 없습니다.
            </span>
            <button
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '40px',
                fontWeight: '700',
                padding: '10px 30px',
                borderRadius: '20px',
                color: '#ffffff',
                backgroundColor: '#FFB600',
                fontSize: '20px',
                cursor: 'pointer',
                borderWidth: 0,
              }}
              onClick={openModal}
            >
              결제하러 가기
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default MyPagePayment;
